export const API_SOURCES_NAME = 'ApiSources';

export const API_END_POINTS = {
  SAVE_APPLY: '/sources/lead/{adId}',
  FETCH_SOURCES: '/sources/topPlayers',
};



// WEBPACK FOOTER //
// ./app/sdk/sources/apiSourcesConstants.js